// extracted by mini-css-extract-plugin
export default {"container":"style_container__AjkVH","nextMobile":"style_nextMobile__3cKJ2"};